import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagUnder12Props {}

const ColorTagUnder12: React.FC<ColorTagUnder12Props> = props => {
  return <ColorTag className="ColorTagUnder12" color="#78A3F7">Under 12</ColorTag>
}

export default ColorTagUnder12;